import React, { useEffect, useState, useCallback } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useOutletContext, useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { myQueries } from "../../../utils/mainTabs/admin/myQueries";
import classes from "./MyQueries.module.scss";
import Course from "./Course/Course";
import Support from "./Support/Support";
import { getAllAssignedQueriesActionHandler } from "../../../store/actions/actionHandlers/adminActionHandler/myQueriesActionHandler";
import { useFetchData } from "../../../hooks/useFetchData";
import { FormattedMessage } from "react-intl";

const MyQueries = () => {
  
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("tab1");
  // const [assignedData, setAssignedData] = useState(null)
  const handleTab1 = () => {
    // update the state to tab1
    setActiveTab("tab1");
  };
  const handleTab2 = () => {
    // update the state to tab2
    setActiveTab("tab2");
  };
  const { setAdminHeader, setAdminNavLinks, setAdminTiles, tenantName } =
    useOutletContext();
  useEffect(() => {
    setAdminHeader("");
    setAdminTiles("");
    setAdminNavLinks(myQueries.navLinks(navigate, tenantName));
  }, [navigate, setAdminHeader, setAdminNavLinks, tenantName]);
  // useEffect(() => {
  //   dispatch(getAllAssignedQueriesActionHandler("SHOTCLASS",0,pageSize,setAssignedData))
  // }, [dispatch])
  return (
    <div className={classes.myQueriesMainBox}>
      <div className={classes.courseSupportTabs}>
        <ul className={classes.nav}>
          <li
            className={activeTab === "tab1" ? classes.active : ""}
            onClick={handleTab1}
          >
            <FormattedMessage id="COURSE_TEXT" />
          </li>
          <li
            className={activeTab === "tab2" ? classes.active : ""}
            onClick={handleTab2}
          >
            <FormattedMessage id="SUPPORT_TEXT" />
          </li>
        </ul>
      </div>
      <div>
        <div className={classes.courseSupportTabsBody}>
          {activeTab === "tab1" ? <Course /> : <Support />}
        </div>
      </div>
    </div>
  );
};

export default MyQueries;
